
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M18.573 2.126L12.315.051a.998.998 0 00-.63 0L5.426 2.126A4.993 4.993 0 002 6.872v5.171c0 6.562 7.005 10.576 9.153 11.65 0 0 .519.307.85.307s.791-.24.791-.24c2.16-.869 9.207-4.281 9.207-11.717V6.872a4.993 4.993 0 00-3.427-4.746zM20 12.043c0 6.182-6.088 9.111-7.953 9.861C10.159 20.96 4 17.459 4 12.043V6.872c0-1.295.826-2.439 2.056-2.848L12 2.053l5.944 1.971A2.998 2.998 0 0120 6.872v5.171zM15.707 9.2l-2.293 2.293 2.293 2.293a.999.999 0 11-1.414 1.414L12 12.907 9.707 15.2a.997.997 0 01-1.414 0 .999.999 0 010-1.414l2.293-2.293L8.293 9.2a.999.999 0 111.414-1.414L12 10.079l2.293-2.293A.999.999 0 1115.707 9.2z"}})])
          )
        }
      }
    